import type { SVGProps } from 'react';
const DawnFlagET = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ET_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-ET_svg__a)">
      <path fill="#20AA46" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path fill="#E92F3B" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        fill="#FADF50"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H0z"
        clipRule="evenodd"
      />
      <path
        fill="#205CCA"
        fillRule="evenodd"
        d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
        clipRule="evenodd"
      />
      <path
        stroke="#FFDB3D"
        strokeWidth={0.667}
        d="M11.196 8.77 11 8.628l-.196.142-.73.53.273-.88.07-.224-.188-.14-.736-.556.91-.008.239-.002.074-.227L11 6.4l.284.863.074.227.24.002.909.008-.736.555-.187.141.069.224.272.88z"
      />
    </g>
  </svg>
);
export default DawnFlagET;
